import React from 'react';

interface PageHeaderProps {
  title: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  return (
    <section
      className="bg-secondary d-flex justify-content-center align-items-center"
      style={{ minHeight: '100px', width: '100%' }}
    >
      <h1 className="fw-bold mb-0">{title}</h1>
    </section>
  );
};

export default PageHeader;
